const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/profile/$id/achievements/$sandbox.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
interface Root {
  playerAchievements: PlayerAchievement[];
  sandboxAchievements: SandboxAchievement[];
}
interface PlayerAchievement {
  _id: string;
  epicAccountId: string;
  sandboxId: string;
  totalXP: number;
  totalUnlocked: number;
  achievementSets: AchievementSet[];
  playerAwards: unknown[];
  playerAchievements: PlayerAchievement2[];
}
interface AchievementSet {
  achievementSetId: string;
  isBase: boolean;
  totalUnlocked: number;
  totalXP: number;
}
interface PlayerAchievement2 {
  playerAchievement: PlayerAchievement3;
}
interface PlayerAchievement3 {
  achievementName: string;
  epicAccountId: string;
  progress: number;
  sandboxId: string;
  unlocked: boolean;
  unlockDate: string;
  XP: number;
  achievementSetId: string;
  isBase: boolean;
}
interface SandboxAchievement {
  _id: string;
  productId: string;
  sandboxId: string;
  achievementSetId: string;
  isBase: boolean;
  numProgressed: number;
  numCompleted: number;
  achievements: Achievement[];
  __v: number;
}
interface Achievement {
  deploymentId: string;
  name: string;
  flavorText: string;
  hidden: boolean;
  unlockedDisplayName: string;
  unlockedDescription: string;
  unlockedIconId: string;
  unlockedIconLink: string;
  lockedDisplayName: string;
  lockedDescription: string;
  lockedIconId: string;
  lockedIconLink: string;
  xp: number;
  completedPercent: number;
}
export const Route = createFileRoute("/{-$locale}/profile/$id/achievements/$sandbox")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      queryClient
    } = context;
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["player-sandbox-achievements", {
        id: params.id,
        sandbox: params.sandbox
      }],
      queryFn: () => httpClient.get<Root>(`/profiles/${params.id}/achievements/${params.sandbox}`).catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["sandbox:base", {
        id: params.sandbox,
        country: "US"
      }],
      queryFn: () => httpClient.get<SingleOffer>(`/sandboxes/${params.sandbox}/base-game`, {
        params: {
          country: "US"
        }
      }).catch(() => null)
    })]);
    return {
      id: params.id,
      sandbox: params.sandbox,
      dehydratedState: dehydrate(queryClient)
    };
  }
});
interface PlayerAchievementStatus extends Achievement {
  unlocked: boolean;
  unlockDate: string;
}